import React, { useEffect } from 'react';
import { Page } from '@components/page';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { Header } from './components/header';
import { Body } from './components/body';
import { fetchUsers } from '@redux/slices/users';
import { fetchDivisions } from '@redux/slices/divisions';
import { fetchApprovalGroups } from '@redux/slices/approval-groups';
import { fetchApprovalMarketing } from '@redux/slices/approval-marketing';
import { CardTable } from '@components/table/styled';
import { Col } from 'antd';
import { translate } from '@components/i18n';

export const Users: React.FC = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchUsers());
        dispatch(fetchDivisions());
        dispatch(fetchApprovalGroups());
        dispatch(fetchApprovalMarketing());
    }, []);

    return (
        <Page
            title={translate('pages.users')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Col span={22} style={{ alignSelf: 'center' }}>
                <h2 style={{ marginTop: '15px' }}>
                    {translate('titlePages.users')}
                </h2>
                <CardTable>
                    <Header />
                    <Body />
                </CardTable>
            </Col>
        </Page>
    );
};
